const Row = ({ label, value }) => (
  <div className="py-3 border-b" style={{ borderColor: "#E2EBE9" }} data-testid={`request-summary-${label.replace(/[^a-z0-9]+/gi, "-").toLowerCase()}`}>
    <p className="text-[11px] font-bold uppercase tracking-wide mb-1" style={{ color: "#1D5C56" }}>{label}</p>
    <p className={`text-sm ${value ? "text-gray-800" : "text-gray-400 italic"} whitespace-pre-wrap`}>{value || "Not provided"}</p>
  </div>
);

export default function SummaryStep({ data, email, error }) {
  return (
    <div data-testid="request-summary-step">
      <div className="flex items-center justify-between mb-1">
        <h2 className="text-xl font-semibold text-gray-900" style={{ fontFamily: "Outfit, sans-serif" }}>Request Summary</h2>
        <span className="inline-block text-xs font-bold px-3 py-1 rounded-full text-white" style={{ backgroundColor: "#1D5C56" }} data-testid="request-summary-category-badge">
          {data.categoryName || "No category selected"}
        </span>
      </div>
      <p className="text-sm text-gray-500 mb-5">Review before sending to the Technofocus triage team.</p>

      <Row label="Verified requestor email" value={email} />
      <Row label="Requestor" value={`${data.reqName || ""}${data.reqRole ? " \u2014 " + data.reqRole : ""}`} />
      <Row label="Sponsoring Microsoft stakeholder" value={data.sponsor} />
      <Row label="Target date" value={data.targetDate} />
      <Row label="Urgency" value={data.urgency} />
      <Row label="Business justification" value={data.justification} />
      <Row label="Request type(s) selected" value={data.subtypes.join(", ")} />
      {Object.entries(data.categoryFields).filter(([, v]) => v).map(([k, v]) => (
        <Row key={k} label={k} value={v} />
      ))}
      <Row label="Expected scale" value={data.scale} />
      <Row label="Budget / PO status" value={data.budget} />
      <Row label="Anticipated support needs" value={data.supportNeeds} />
      <Row label="Reporting needs" value={data.reportingNeeds} />
      <Row label="Dependency systems" value={data.dependencies.join(", ")} />

      {error && (
        <p className="text-sm mt-4" style={{ color: "#B5453D" }} data-testid="request-submit-error">{error}</p>
      )}
    </div>
  );
}
